// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './components/App'
import store from './store'

import 'bootstrap/dist/css/bootstrap.css'

import { mapMutations, mapGetters, mapActions } from 'vuex'
import Vue from 'vue'

Vue.config.productionTip = false

/**
 * Initialize the application
 * @param {String} el - application element (#app)
 * @param {String} room - name of the room
 * @param {String} width - width of the chat in px, default 300px
 * @param {String} height - height of the chat in px, default 360px
 * @param {String} service - link to the chat backend
 * @param {String} language - UI language, default EN
 * @param {Number} maxMessageLength - max length of the message, default 255
 * @param {Number} maxMessageCount - max length of the message, default 50
 * @param {Number} timeBetweenMessages - min time between messages, default 0 seconds
 * @param {Number} maxEqualMessages - max length of sequence of equal messages, default 100
 */
export function init ({ el, service, room, width = '300px', height = '360px', language = 'EN',
                        maxMessageLength = 255, maxMessagesCount = 50, timeBetweenMessages = 0,
                        maxEqualMessages = 100 }) {
  if (!el) {
    throw new Error('El is not provided')
  }

  if (!service) {
    throw new Error('Service is not provided')
  }

  if (!room) {
    throw new Error('Room is not provided')
  }

  const languagesArr = store.state.language.languages
  let supportedLanguages = languagesArr.map(lang => lang.code)
  if (supportedLanguages.indexOf(language) === -1) {
    throw new Error(`Incorrect language, supported: ${supportedLanguages}`)
  }

  /* eslint-disable no-new */
  new Vue({
    store,
    el: el,
    template: '<App/>',
    components: { App },

    computed: {
      ...mapGetters([
        'connected',
        'language',
        'user'
      ])
    },

    methods: {
      ...mapMutations([
        'setRoom',
        'setStyle',
        'setService',
        'setLanguage',
        'clearMessages',
        'clearErrorMessages',
        'setMaxMessageLength',
        'setMaxMessagesCount',
        'setMaxEqualMessages',
        'clearLoginErrorText',
        'setTimeBetweenMessages'
      ]),

      ...mapActions([
        'connect'
      ])
    },

    mounted: function () {
      this.setRoom({ room })
      this.setStyle({ height, width })
      this.setService({ service })
      this.setMaxMessageLength({ maxMessageLength })
      this.setMaxMessagesCount({ maxMessagesCount })
      this.setTimeBetweenMessages({ timeBetweenMessages })
      this.setMaxEqualMessages({ maxEqualMessages })

      this.clearLoginErrorText()
      this.clearErrorMessages()

      // If language was changed before refresh
      if (!this.language) {
        this.setLanguage({ language })
      }

      // Reconnect after page refresh
      if (this.connected && this.user) {
        this.connect({ user: this.user })
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/main.js